export const serviceWorkerApi = {
  register: async () => await navigator.serviceWorker.register('/service-worker.js'),
  isActive: () => navigator.serviceWorker.controller !== null,
  isSupported: () => 'serviceWorker' in navigator,
};
